import {
  BooleanInput,
  Edit,
  Identifier,
  ReferenceInput,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextInput,
  Toolbar,
  usePermissions,
  useTranslate,
} from 'react-admin';

const UserDeviceTokenEditToolbar = (props: any) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const UserDeviceTokenEditEmbedded = ({ id }: { id?: Identifier }) => {
  const { permissions } = usePermissions();
  const translate = useTranslate();
  return (
    <Edit title=" " id={id}>
      <SimpleForm toolbar={<UserDeviceTokenEditToolbar />}>
        <ReferenceInput source="user_id" reference="user">
          <SelectInput optionText="display_name" validate={[required()]} disabled={permissions !== 'master'} />
        </ReferenceInput>
        <TextInput source="device_id" validate={[required()]} disabled={permissions !== 'master'} />
        <TextInput source="fcm_token" validate={[required()]} disabled={permissions !== 'master'} multiline fullWidth />
        <BooleanInput source="is_subscribed" />
      </SimpleForm>
    </Edit>
  );
};

export default UserDeviceTokenEditEmbedded;
